export default __webpack_public_path__ + "static/media/wrist-watch.c6e618fa.svg";